<template>
  <div class="layout_container">
    <header-section />
    <top-section />
  </div>
</template>

<script>
import HeaderSection from './component/header'
import TopSection from './component/topSection'
export default {
  components: { HeaderSection, TopSection },
}
</script>

<style>
html {
  scroll-behavior: smooth; /* 启用平滑滚动 */
}
</style>

